import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'formatMomentDate'
})
export class FormatMomentDatePipe implements PipeTransform {
  transform(value: string | moment.Moment, args?: string): any {
    if (!value) {
      return value;
    }
    if (typeof value === 'string') {
      return value
        ? moment(value, 'YYYY-MM-DD').format(args ? args : 'DD/MM/YYYY')
        : '';
    } else {
      return value ? value.format(args ? args : 'DD/MM/YYYY') : '';
    }
  }
}
